const reviewsApi = ({ apiClient }) => ({
  list(params = {}, headers = {}) {
    return apiClient.get('/reviews/', {}, params, headers)
  },

  updateStatus(id, data, headers = {}) {
    return apiClient.patch(`/reviews/${id}/status`, data, headers)
  },

  toggleSelected(id, data, headers = {}) {
    return apiClient.patch(`/reviews/${id}/select`, data, headers)
  },

  destroy(id, headers = {}) {
    return apiClient.delete(`/reviews/${id}`, headers)
  },
})

export default reviewsApi
